import { FC, Fragment, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
// Types
import MediaTypes from 'types/MediaTypes';
import BannerTypes from 'types/BannerTypes';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectBanner } from 'store/pages/pagesSelectors';
// Hooks
import useToggle from 'hooks/useToggle';
import useNavigateTo from 'hooks/useNavigateTo';
// Dialogs
import BrandVideoDialog from 'dialogs/BrandVideo.dialog';
import ImageDialog from 'dialogs/Image.dialog';
import VideoDialog from 'dialogs/Video.dialog';
import BannerTextDialog from 'dialogs/BannerText.dialog';

const MediaPage:FC = () => {
  const [ searchParams ] = useSearchParams();
  const mediaType = searchParams.get('mediaType');

  const banner = useAppSelector(selectBanner);

  const navigateTo = useNavigateTo();
  const { open:openBrandDialog, toggle:toggleBrandDialog } = useToggle();
  const { open:openImageDialog, toggle:toggleImageDialog } = useToggle();
  const { open:openVideoDialog, toggle:toggleVideoDialog } = useToggle();
  const { open:openBannerTextDialog, toggle:toggleBannerTextDialog } = useToggle();

  useEffect(() => {
    if (!mediaType) {
      if (!banner) {
        navigateTo('pages-handler');
        return;
      }
      if (banner.type === BannerTypes.Image) toggleImageDialog();
      if (banner.type === BannerTypes.Video) toggleVideoDialog();
      if (banner.type === BannerTypes.Text) toggleBannerTextDialog();
    }
    if ( mediaType === MediaTypes.BrandVideo ){
      toggleBrandDialog();
    }
    // eslint-disable-next-line
  }, [mediaType]);

  const handleCloseBrandDialog = () => {
    toggleBrandDialog();
    navigateTo('countdown');
  }

  return (
    <Fragment>
      {openBrandDialog ? (
        <BrandVideoDialog
          onClose={handleCloseBrandDialog}
        />
      ) : null}
      
      {openImageDialog ? (
        <ImageDialog
          onClose={toggleImageDialog}
        />
      ) : null}
      {openVideoDialog ? (
        <VideoDialog
          onClose={toggleVideoDialog}
        />
      ) : null}
      {openBannerTextDialog ? (
        <BannerTextDialog
          onClose={toggleBannerTextDialog}
        />
      ) : null}
    </Fragment>
  )
}

export default MediaPage;
